<template>
  <div v-if="showTelecom">
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__1">Telecom</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Telecom - General Telecom Details</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Plan Featured:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-checkbox v-model="telecom_plan_featured" class="d-inline-block"/>
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Featured Plan Name:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="telecom_featured_plan_name" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Contract Required:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-checkbox v-model="telecom_contract_required" class="d-inline-block"/>
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Internet Speed:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="telecom_internet_speed" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Telecom - Pricing</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Monthly Cost ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="telecom_monthly_cost" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Lower Featured Monthly Cost ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field
          outlined
          dense
          v-model="telecom_lower_featured_monthly_cost"
        />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Upper Featured Monthly Cost ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field
          outlined
          dense
          v-model="telecom_upper_featured_monthly_cost"
        />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Activation Charge ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="telecom_activation_charge" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Installation Charge ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="telecom_installation_charge" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Local Calling Monthly Cost ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field
          outlined
          dense
          v-model="telecom_local_calling_monthly_charge"
        />
      </v-col>
    </v-row>
    <!-- <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Local Distance Monthly Charge ($):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-text-field v-model="local_distance_monthly_charge"/>
            </v-col>
        </v-row> -->
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Long Distance Monthly Cost ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field
          outlined
          dense
          v-model="telecom_long_distance_monthly_charge"
        />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Telecom - Introductory Pricing Details</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Introductory Cost ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="telecom_introductory_cost" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Introductory Period (Months):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field
          outlined
          dense
          v-model="telecom_introductory_period_months"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Telecom",
  props: ["showTelecom"],
  computed: {
    ...mapGetters({
      sector: "ProductData/getSector",
    }),
    telecom_plan_featured: {
      get: function () {
        return this.$store.getters["ProductData/getTelecomPlanFeatured"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTelecomPlanFeatured", o);
      },
    },
    telecom_featured_plan_name: {
      get: function () {
        return this.$store.getters["ProductData/getTelecomFeaturedPlanName"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTelecomFeaturedPlanName", o);
      },
    },
    telecom_contract_required: {
      get: function () {
        return this.$store.getters["ProductData/getTelecomContractRequired"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTelecomContractRequired", o);
      },
    },
    telecom_internet_speed: {
      get: function () {
        return this.$store.getters["ProductData/getTelecomInternetSpeed"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTelecomInternetSpeed", o);
      },
    },
    telecom_monthly_cost: {
      get: function () {
        return this.$store.getters["ProductData/getTelecomMonthlyCost"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTelecomMonthlyCost", o);
      },
    },
    telecom_lower_featured_monthly_cost: {
      get: function () {
        return this.$store.getters[
          "ProductData/getTelecomLowerFeaturedMonthlyCost"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setTelecomLowerFeaturedMonthlyCost",
          o
        );
      },
    },
    telecom_upper_featured_monthly_cost: {
      get: function () {
        return this.$store.getters[
          "ProductData/getTelecomUpperFeaturedMonthlyCost"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setTelecomUpperFeaturedMonthlyCost",
          o
        );
      },
    },
    telecom_activation_charge: {
      get: function () {
        return this.$store.getters["ProductData/getTelecomActivationCharge"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTelecomActivationCharge", o);
      },
    },
    telecom_installation_charge: {
      get: function () {
        return this.$store.getters["ProductData/getTelecomInstallationCharge"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTelecomInstallationCharge", o);
      },
    },
    telecom_local_calling_monthly_charge: {
      get: function () {
        return this.$store.getters[
          "ProductData/getTelecomLocalCallingMonthlyCharge"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setTelecomLocalCallingMonthlyCharge",
          o
        );
      },
    },
    telecom_local_distance_monthly_charge: {
      get: function () {
        return this.$store.getters[
          "ProductData/getTelecomLocalDistanceMonthlyCharge"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setTelecomLocalDistanceMonthlyCharge",
          o
        );
      },
    },
    telecom_long_distance_monthly_charge: {
      get: function () {
        return this.$store.getters[
          "ProductData/getTelecomLongDistanceMonthlyCharge"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setTelecomLongDistanceMonthlyCharge",
          o
        );
      },
    },
    telecom_introductory_cost: {
      get: function () {
        return this.$store.getters["ProductData/getTelecomIntroductoryCost"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTelecomIntroductoryCost", o);
      },
    },
    telecom_introductory_period_months: {
      get: function () {
        return this.$store.getters[
          "ProductData/getTelecomIntroductoryPeriodMonths"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setTelecomIntroductoryPeriodMonths",
          o
        );
      },
    },
  },
};
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/banking'
</style>